export default __webpack_public_path__ + "static/media/FoodDeliveryApp.a45e155e.webp";